export class DateTimeFormatter {
    static toYYYYMMDDHHMMSS(date: Date|number): string {
        const d = new Date(date);
        const formatDigits = (v: number): string => {
            return v < 10 ? '0' + v : v.toString();
        }
        return `${d.getFullYear()}-${formatDigits(d.getMonth() + 1)}-${formatDigits(d.getDate())} ${formatDigits(d.getHours())}:${formatDigits(d.getMinutes())}:${formatDigits(d.getSeconds())}`;
    }

    static join(date: Date|number, parts: any[], separator: string) {
        const format = (m: any) => {
            return new Intl.DateTimeFormat(undefined, m).format(date);
        }
        return parts.map(format).join(separator);
    }

}